import PropTypes from 'prop-types';
import { Skeleton } from '@aimsos/ui';

/**
 * Loading placeholder for the catalog. Rendered inside the **same** layout
 * wrapper as the loaded rows so swapping one for the other causes no shift.
 */
function WidgetLibrarySkeleton({ count }) {
  return Array.from({ length: count }, (_, index) => (
    <div key={`widget-skeleton-${index}`} className="rounded-lg border border-edge bg-surface px-5 py-4">
      <div className="flex items-center gap-3">
        <Skeleton width={24} height={24} borderRadius={6} />
        <Skeleton width="52%" height={14} borderRadius={6} />
        <div className="ml-auto">
          <Skeleton width={92} height={20} borderRadius={9999} />
        </div>
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        <Skeleton width={74} height={20} borderRadius={9999} />
        <Skeleton width={80} height={20} borderRadius={9999} />
        <Skeleton width={110} height={20} borderRadius={9999} />
      </div>
    </div>
  ));
}

WidgetLibrarySkeleton.propTypes = {
  count: PropTypes.number.isRequired,
};

export default WidgetLibrarySkeleton;
